// components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { CircularProgress, Box } from "@mui/material";

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const location = useLocation();
  const { isLoggedIn, user } = useSelector((state) => state.globalData);
  
  // Show loading spinner only if we're still initializing auth state
  if (isLoggedIn === undefined) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Check if user is authenticated
  const isAuthenticated = isLoggedIn || localStorage.getItem("user-token");

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return (
      <Navigate 
        to="/authentication/sign-in" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // Check role-based access if required
  if (requiredRole && user && user.role !== requiredRole) {
    return (
      <Navigate 
        to="/dashboard" 
        state={{ error: "You don't have permission to access this page" }} 
        replace 
      />
    );
  }

  return children;
};

export default ProtectedRoute;
